































import Vue from 'vue';
import { mapState, mapGetters } from 'vuex';

import Paying from '@/types/Paying';
import OrderAPI from '@/services/OrderAPI';
import { AxiosError, AxiosResponse } from 'axios';
import Payment from '@/types/Payment';

import utilMixin from '@/mixin/Util';

export default Vue.extend({
    name: 'PaymentSelector',

    props: {
        value: Boolean,
        currentPayment: Object as () => Payment,
        orderId: String,
        readonly: Boolean,
        isBoxed: {
            type: Boolean,
            default: true
        }
    },

    mixins: [utilMixin],

    data() {
        return {
            payment: new Payment(),
            error: {
                save: ''
                },
            isLoading: false
        };
    },

    created() {
		if (this.currentPayment) {
            this.payment = JSON.parse(JSON.stringify(this.currentPayment));
        }
    },

    computed: {
        ...mapState(['payings']),

        ...mapGetters(['getCurrencySymbol', 'getLanguage'])
    },

    methods: {
        input(): void {
            this.$emit('input', this.isChangesMade());
        },

        setPayment(): void {
            this.error.save = '';
            if (!this.payment || !this.payment.payingId) {
                this.error.save = this.$text('mustSupplyPaymentMethod');
                return;
            }

            const handleResponse = (response: AxiosResponse) => {
                    if (response.data) {
                        this.$emit('input', true);
                        this.$store.commit('setOrder', response.data);
                    }
                };

            const handleError = (error: AxiosError) => {
                    if (error.response) {
                        this.error.save = error.response.data.message;
                    }
                };

            this.isLoading = true;
            OrderAPI
                .setPayment(this.orderId, this.payment)
                .then(handleResponse)
                .catch(handleError)
                .finally(() => this.isLoading = false);
        },

        extraText(paying: Paying): string {
            const text = new Array<string>();
            if (paying.cost.value !== 0) {
                text.push(this.$text('cost') + ' ' + paying.cost.value + ' ' + this.getCurrencySymbol(paying.cost.currencyCode));
            }
            if (paying.percentageCostOfTotal !== 0) {
                text.push(this.$text('payment-selector.extra.1') + paying.percentageCostOfTotal + this.$text('payment-selector.extra.2'));
            }
            return text.join(', ');
        },

        isChangesMade(): boolean {
            return !this.currentPayment && !!this.payment ||
                this.currentPayment !== undefined && this.payment !== undefined &&
                this.currentPayment.payingId !== this.payment.payingId;
        }
    }
});
